import styles from '../styles/font/index.module.scss'
import { List, Typography, Card, Input, Tag } from 'antd'
import Layout from '../../components/MyLayout'
import React from 'react'
import { NextPage, NextPageContext } from 'next';
import { fontClass, getFontList } from '../../constants/api'
import { http } from '../../utils/api'
import { useSelector } from 'react-redux'
import { State } from '../../@types/reducer'
import { Search as SearchIcon } from '@icon-park/react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Meta from 'antd/lib/card/Meta';
import { Item, Class } from '../../@types/font';
import { colorPrimary } from '../../constants/heads';
const { Search } = Input;
type FontProps = {
  page: number
  weight: string | string[]
  category: string | string[]
  style: string | string[]
  by: string | string[]
  list: {
    list: Item[]
    total: number
  }
  classList: Class[]
}

const Font: NextPage<FontProps> = (props) => {
  const router = useRouter()
  const { query } = useRouter()
  const { page, weight, category, style, by } = props
  const { total, list } = props.list
  const classList = props.classList
  const head = {
    title: `搜图字库-提供百款免费商用字体在线生成以及下载`,
    keywords: `免费商用字体,字体下载,书法字体在线生成,英文字体在线生成,字体在线生成,字体下载`,
    description: `拥有百款免费商用字体在线生成以及下载，可以通过图片找字体。日文字体、英文字体、黑体、宋体、仿宋、楷体、圆体、书法体、装饰字、手写体。无需安装在线一键生成即可使用。`
  }
  const { userInfo, baseUrl, cdnUrl, responsive } = useSelector((state: State) => state)
  const { isXs, isSm, isMd, isXxl } = responsive

  const onSearch = (value: any) => {
    const text = value.constructor === String ? String(value) : value.target.defaultValue
    router.push(`/font?key=${text}`)
  }


  return (
    <Layout className={styles.font} head={head}>
      <div className={styles.content}>
        <Search
          placeholder="请输入字体名称进行搜索"
          enterButton={<SearchIcon style={{ padding: '0 15px' }} strokeWidth={3} theme="outline" size="22" fill="#fff" strokeLinecap="butt" />}
          size="large"
          onPressEnter={onSearch}
          onSearch={onSearch}
        />
        <Card>
          <div>
            <span>语言：</span>
            <Link key="k" href={
              {
                pathname: '/font',
                query: { ...query, category: '', p: 1 },
              }
            } >
              <a>
                <Tag style={category == '' ? { color: '#fff' } : {}} color={category == '' ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {classList.map((v, k: number) => (
              v.level == 1 && <Link key={k} href={{
                pathname: '/font',
                query: { ...query, category: v._id, p: 1 },
              }} >
                <a>
                  <Tag style={category == v._id ? { color: '#fff' } : {}} color={category == v._id ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>
          <div>
            <span>风格：</span>
            <Link key="k" href={
              {
                pathname: '/font',
                query: { ...query, style: '', p: 1 },
              }
            } >
              <a>
                <Tag style={style == '' ? { color: '#fff' } : {}} color={style == '' ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {classList.map((v, k: number) => (
              v.level == 2 && <Link key={k} href={{
                pathname: '/font',
                query: { ...query, style: v._id, p: 1 },
              }} >
                <a>
                  <Tag style={style == v._id ? { color: '#fff' } : {}} color={style == v._id ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>
          <div>
            <span>粗细：</span>
            <Link key="k" href={
              {
                pathname: '/font',
                query: { ...query, weight: '', p: 1 },
              }
            } >
              <a>
                <Tag style={weight == '' ? { color: '#fff' } : {}} color={weight == '' ? colorPrimary : '#fff'}>全部</Tag>
              </a>
            </Link>
            {classList.map((v, k: number) => (
              v.level == 3 && <Link key={k} href={{
                pathname: '/font',
                query: { ...query, weight: v._id, p: 1 },
              }} >
                <a>
                  <Tag style={weight == v._id ? { color: '#fff' } : {}} color={weight == v._id ? colorPrimary : '#fff'}>{v.name}</Tag>
                </a>
              </Link>
            ))}
          </div>
          <div>
            <span> 排序：</span>
            <Link key="timestamp" href={{
              pathname: '/font',
              query: { ...query, by: "timestamp", p: 1 },
            }} >
              <a><Tag style={by == 'timestamp'? { color: '#fff' } : {}} color={by == 'timestamp' || by == '' ? colorPrimary : '#fff'}>最新</Tag></a>
            </Link>
            <Link key="visit" href={{
              pathname: '/font',
              query: { ...query, by: "visit", p: 1 },
            }} >
              <a>
                <Tag style={by == 'visit'? { color: '#fff' } : {}} color={by == 'visit' ? colorPrimary : '#fff'}>热门</Tag>
              </a>
            </Link>
            <Link key="like" href={{
              pathname: '/font',
              query: { ...query, by: "like", p: 1 },
            }} >
              <a>
                <Tag style={by == 'like'? { color: '#fff' } : {}} color={by == 'like' ? colorPrimary : '#fff'}>下载</Tag>
              </a>
            </Link>
          </div>
        </Card>
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            itemRender: (current, type, originalElement) => {
              if (type === 'page') {
                return <Link href={{
                  pathname: '/font',
                  query: { ...query, p: current },
                }} ><a>{current}</a></Link>
              }
              return originalElement;
            },
            current: page,
            total,
            pageSize: 16,
            hideOnSinglePage: true
          }}
          dataSource={list}
          footer={null}
          grid={{
            gutter: 0, xs: 1, sm: 3, md: 3, lg: 3, xl: 4, xxl: 4,
          }}
          renderItem={item => (
            <List.Item style={{ marginBottom: '0px' }}>
              <Link href={
                {
                  pathname: '/font/[id]',
                  query: { id: item._id },
                }
              } >
                <a target="_blank" title={item.title}>
                  <Card
                    style={{ width: '100%', marginBottom: 0 }}
                    cover={
                      <img
                        alt={item.title}
                        src={cdnUrl + item.img}
                      />
                    }
                  >
                    <Meta
                      title={item.title}
                    />
                  </Card>
                </a>
              </Link>
            </List.Item>
          )}
        />
      </div>
    </Layout>
  )
}

Font.getInitialProps = async ({ req, res, err, query }: NextPageContext) => {
  const page = query.p || 1;
  const category = query.category || "";
  const style = query.style || "";
  const weight = query.weight || "";
  const by = query.by || 'timestamp'
  const key = query.key || ''
  const limit = 16
  const data: any = await Promise.all([http(fontClass), http(getFontList, {
    style,
    weight,
    page,
    category,
    limit,
    by,
    key,
  }, req)])
  const classList: any = data[0].data
  const list: any = data[1].data
  return {
    list: list,
    classList: classList.list,
    page: Number(page),
    style,
    weight,
    category,
    limit,
    by,
  }
}

export default Font